import { render } from "./RejectedCookiesAlert.vue?vue&type=template&id=45567010&scoped=true"
import script from "./RejectedCookiesAlert.vue?vue&type=script&lang=js"
export * from "./RejectedCookiesAlert.vue?vue&type=script&lang=js"

import "./RejectedCookiesAlert.vue?vue&type=style&index=0&id=45567010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45567010"]])

export default __exports__